import {EotLogo} from './src/EotLogo.js';
export {EotLogo} from './src/EotLogo.js';


customElements.define('eot-logo', EotLogo);